import i18nPackage from "../../../i18n/i18n";
import ConfirmationBlock, {
	CommonConfirmationBlockProps,
	CompactVariantProp,
	ConfirmationBlockSkeleton,
	ConfirmationRow,
	RadioVariantProp,
} from "./ConfirmationBlock";
import AssessmentDetailsIcon from "../../images/confirmation/assessment-details.svg?react";
import { formatLiveSessionDate } from "../../live/liveHelper";
import AddInstructionIcon from "../../images/confirmation/add-instruction.svg?react";

type BaseStandaloneDetailsBlockProps = CommonConfirmationBlockProps;

type RadioStandaloneDetailsBlockProps = BaseStandaloneDetailsBlockProps &
	RadioVariantProp & {
		title: string;
		description?: string;
		dueDate: Date | null;
	};

type CompactStandaloneDetailsBlockProps = BaseStandaloneDetailsBlockProps & CompactVariantProp;

type StandaloneDetailsBlockProps = RadioStandaloneDetailsBlockProps | CompactStandaloneDetailsBlockProps;

function RadioStandaloneDetailsBlock({ title, description, dueDate, ...props }: RadioStandaloneDetailsBlockProps) {
	return (
		<ConfirmationBlock
			{...props}
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.assessmentDetails")}
			icon={<AssessmentDetailsIcon />}
			targetPageName="assessmentDetails"
		>
			<ConfirmationRow title={i18nPackage.t("editQuizPage.confirmationBlockTSX.assessmentTitle")} description={title} />
			{description && (
				<ConfirmationRow
					title={i18nPackage.t("editQuizPage.confirmationBlockTSX.emailInstructions")}
					description={description}
					tooltipType="ellipsis"
				/>
			)}
			{dueDate && (
				<ConfirmationRow
					title={i18nPackage.t("editQuizPage.confirmationBlockTSX.assessmentDueDate")}
					description={formatLiveSessionDate(dueDate)}
				/>
			)}
		</ConfirmationBlock>
	);
}

function CompactStandaloneDetailsBlock(props: CompactStandaloneDetailsBlockProps) {
	return (
		<ConfirmationBlock
			{...props}
			targetPageName="assessmentDetails"
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.assessmentDetails")}
			buttonVariant={"link"}
			onEdit={props.onEdit}
			buttonText={i18nPackage.t("editQuizPage.confirmationBlockTSX.manageAssessmentDetails")}
		/>
	);
}

export function StandaloneDetailsBlock(props: StandaloneDetailsBlockProps) {
	if (props.loading) return <ConfirmationBlockSkeleton />;

	if (props.variant === "radio") {
		return <RadioStandaloneDetailsBlock {...props} />;
	}

	return <CompactStandaloneDetailsBlock {...props} />;
}

type StandaloneInstructionsBlockProps = {
	children?: React.ReactNode;
} & CommonConfirmationBlockProps;

export function StandaloneInstructionsBlock({ children, ...props }: StandaloneInstructionsBlockProps) {
	return (
		<ConfirmationBlock
			variant="radio"
			{...props}
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.instructions")}
			icon={<AddInstructionIcon />}
			targetPageName="assessmentDetails"
		>
			{children}
		</ConfirmationBlock>
	);
}

type StandaloneTestTakersBlockProps = CommonConfirmationBlockProps;

export function StandaloneTestTakersBlock(props: StandaloneTestTakersBlockProps) {
	return (
		<ConfirmationBlock
			{...props}
			targetPageName="inviteTestTakers"
			title={i18nPackage.t("editQuizPage.confirmationBlockTSX.testTakers")}
			buttonVariant={"link"}
			onEdit={props.onEdit}
			buttonText={i18nPackage.t("editQuizPage.confirmationBlockTSX.manageTestTakers")}
		/>
	);
}
